import axios from "axios";

const baseURL = process.env.REACT_APP_BASE_URL;

export const Version = {
  version: "1.6.5",
};

export let networkStatus = "Production 🟢";

if (baseURL?.includes("tatvagyan")) {
  networkStatus = "Test 🔴";
} else if (baseURL?.includes("localhost")) {
  networkStatus = "Local ⚪";
}

export default axios.create({
  baseURL,
});
